import { InitialValues, ValidationErrors } from 'forms/types';
import { isPresent } from 'forms/validators';

import { PolicyFeaturesFormValues } from '../form/types';

export const validate = ({
  ownOccupationPolicy,
  residualDisabilityPolicy,
  noncancellable,
}: InitialValues<PolicyFeaturesFormValues>): ValidationErrors<PolicyFeaturesFormValues> => ({
  ownOccupationPolicy: isPresent(ownOccupationPolicy),
  residualDisabilityPolicy: isPresent(residualDisabilityPolicy),
  noncancellable: isPresent(noncancellable),
});
